import { TermRepository } from '../domain/repositories/TermRepository'
import { TermDatasource } from './datasources/TermDatasource'

export function termRepositoryAdapter(
  termDatasource: TermDatasource
): TermRepository {
  return {
    async getUserTermList(userId, language) {
      return await termDatasource.getUserTermList(userId, language)
    },
    async userAcceptTerm(userId, device) {
      return await termDatasource.userAcceptTerm(userId, device)
    }
  }
}
